import { router } from '@/main';
import config from '@/lib/config';
import http from '@/lib/http';
const LOGIN_URL = 'auth';

import VueJwtDecode from 'vue-jwt-decode';
export default {

  user: {
    authenticated: false,
    loader: false,
    sections: []
  },

  login(context, creds, redirect) {
    console.log(creds)
    let myself = this;
    return http.post('auth', creds, (error, data) => {
      console.log('After login', data);

      if (error || data.error == 'UNAUTHORIZED') {
        context.error = 'Invalid Credentials';
      } else {
        if (data.access_token) {
          // sessionStorage.setItem('token', data.access_token);
          localStorage.setItem('token', data.access_token);
          localStorage.setItem('refresh_token', data.refresh_token);
          var j = VueJwtDecode.decode(localStorage.getItem("token"));
          try {
              myself.user.sections = j.identity.sections;
          } catch (error) {
              myself.user.sections = j.sub.sections;
          }
          myself.user.authenticated = true;
          const section = myself.user.sections[0].toLowerCase();
          console.log('section', section, redirect);
          if (redirect)
            context.$router.push({ name: section });
        } else {
          context.error = data.msg;
        }
      }
    });
  },

  logout(context) {
    // sessionStorage.removeItem('token')
    localStorage.removeItem('token');
    localStorage.clear();
    let _this = this;
    return http.delete('auth/logout', {}, (error, response) => {
      console.log('After login', response);
      localStorage.removeItem('token');
      localStorage.clear();
      _this.user.authenticated = false;
      _this.user.sections = [];
      context.$router.push({ name: 'login' });
    });
  },

  checkAuth() {
    var jwt = localStorage.getItem('token');
    if (jwt) {
      this.user.authenticated = true;
      var j = VueJwtDecode.decode(localStorage.getItem("token"));
      try {
          this.user.sections = j.identity.sections;
      } catch (error) {
          this.user.sections = j.sub.sections;
      }
    }
    else {
      this.user.authenticated = false;
      this.user.sections = [];
    }
  },


  getAuthHeader() {
    return 'Bearer ' + localStorage.getItem('token');
    // return 'JWT ' + sessionStorage.getItem('token')

  }
}



// WEBPACK FOOTER //
// ./src/lib/auth.js